import { createdATFilter } from 'modules/common/constants';

export const productTemplateFilters = [createdATFilter];
